// シンプルタイマー（simpleTimer / simpleTimerControl / simpleTimerDesign）共通の定義とロジック。
// 3コンポーネントで重複していたプリセット・フォント・時刻フォーマットをここに集約する。

// localStorage のキー定義（全コンポーネントで共有）
export const TIMER_KEYS = {
  seconds: 'timerSeconds',
  running: 'timerRunning',
  mode: 'timerMode',
  showBg: 'timerShowBg',
  presetIndex: 'timerPresetIndex',
  font: 'timerFont',
};

// カラープリセット（文字色 / 背景色 / ボーダー色）
export const COLOR_PRESETS = [
  { text: '#1a56db', bg: '#e8f0fe', border: '#a4c2f4' },
  { text: '#166534', bg: '#e6f4ea', border: '#81c995' },
  { text: '#9333ea', bg: '#f3e8ff', border: '#c4b5fd' },
  { text: '#c2410c', bg: '#fff1e6', border: '#fdba74' },
  { text: '#be185d', bg: '#fce7f3', border: '#f9a8d4' },
  { text: '#1e293b', bg: '#f1f5f9', border: '#94a3b8' },
];

// フォント定義。cls は表示用、adjust は垂直位置補正クラス（フォントメトリクス対策）
export const TIMER_FONTS = [
  { value: 'Open Sans', cls: 'font1', adjust: '' },
  { value: 'Iceland', cls: 'font2', adjust: '' },
  { value: 'Josefin Sans', cls: 'font3', adjust: 'font-josefin' },
  { value: 'Oxanium', cls: 'font4', adjust: 'font-oxanium' },
];

export const DEFAULT_FONT = 'Open Sans';

// 選択中フォントから垂直補正クラス名を返す
export function fontAdjustClass(font) {
  const found = TIMER_FONTS.find(f => f.value === font);
  return found ? found.adjust : '';
}

export default {
  data() {
    return {
      totalSeconds: 0,
      colorPresets: COLOR_PRESETS,
      timerFonts: TIMER_FONTS,
    };
  },
  computed: {
    timerSign() {
      return this.totalSeconds < 0 ? '-' : '';
    },
    timerHours() {
      const h = Math.floor(Math.abs(this.totalSeconds) / 3600);
      return h > 0 ? h.toString().padStart(2, '0') : '';
    },
    timerMinutes() {
      return Math.floor((Math.abs(this.totalSeconds) % 3600) / 60).toString().padStart(2, '0');
    },
    timerSeconds() {
      return (Math.abs(this.totalSeconds) % 60).toString().padStart(2, '0');
    },
  },
};
